module.exports = __webpack_public_path__ + "img/btn_tab_active.5fa588ca.png";